import { render } from "./products-featured.vue?vue&type=template&id=62f55e11"
import script from "./products-featured.vue?vue&type=script&lang=js"
export * from "./products-featured.vue?vue&type=script&lang=js"

import "./products-featured.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__